import { IonAccordionGroup, IonAccordion, IonList, IonActionSheet, IonRouterLink, IonSpinner, IonApp, IonContent, IonPage, IonHeader, IonTitle, IonButtons, IonModal, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { useState, useEffect }  from 'react';

import NServer, { UIElement } from "../components/NServer";
import { showAlert, showConfirm } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr, GetLanguage } from "../language/Language";

import '../pages/Main.css'; 
import '../pages/ChatMsg.css';

interface LikeErrProp {
    isOpen : any,
    onDidDismiss : any,
    onSelect : any
};

export interface Location {
    id : string,
    name_en : string,
    name_mm : string,
    owner : string,
    children : Location[];
}

// retrieve the correct name
export const locationName = (s : Location) => {
    if (GetLanguage() == "mmun")
        return s.name_mm;
    // else
    return s.name_en;
}

const LocationSelector : React.FC<LikeErrProp> = ({ isOpen, onDidDismiss, onSelect }) => {
    
    const [loading, setLoading] = useState(false);
    const [locations, setLocations] = useState<Location[]>([]);

    const router = useIonRouter();

    // search the marketplace
    useEffect( ()=> { 
        // load from server
        if (isOpen)
            loadServer();
    }, [isOpen]);

    // click on item
    const doSelect = (s : Location) => {
        onSelect(s);
        onDidDismiss();
    }

    // load data from server
    const loadServer = async () => {
        setLoading(true);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

		var server = new NServer();
        await server.getList("nc_locations", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // console.log("Loc: " + JSON.stringify(server.data));
            setLocations(server.data);
        }

        setLoading(false);
    }

    return (
         <IonModal
            isOpen={isOpen}
            initialBreakpoint={ 0.8 }
            onDidDismiss={onDidDismiss}>
            <div className="ion-page">
                <IonToolbar id="modal">
                    <IonTitle><h5>{ GetStr(LANGUAGE.TXT_LOC_SELECT_TITLE) }</h5></IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={onDidDismiss}>
                            <IonIcon icon={closeOutline} size="large"/>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                <IonContent>
                    {
                        loading ?
                    <div className="headerCenter">
                        <IonSpinner name="crescent" />
                    </div>
                        :
                    <IonList className="list-80">
                        <IonAccordionGroup value="1">
                    {
                        locations.map((s) => (
                            <IonAccordion key={s.id} value={s.id}>
                                <IonItem slot="header" color="light">
                                    <IonLabel>{ locationName(s) }</IonLabel>
                                </IonItem>
                                <IonItem slot="content" lines="full" detail={true} onClick={()=> doSelect(s)}>
                                    <IonLabel>{ locationName(s) }</IonLabel>
                                </IonItem>
                                {
                                    s.children.map( (d) => (
                                <IonAccordionGroup key={d.id} slot="content">
                                    <IonAccordion value={d.id}>
                                        <IonItem slot="header" color="light">
                                            <IonLabel>{ locationName(d) }</IonLabel>
                                        </IonItem>
                                        <IonItem href="#" slot="content" lines="full" detail={true} onClick={()=> doSelect(d)}>
                                            <IonLabel>{ locationName(d) }</IonLabel>
                                        </IonItem>
                                        {
                                            d.children.map( (e) => (
                                        <IonItem key={e.id} href="#" slot="content" lines="full" detail={true} onClick={()=> doSelect(e)}>
                                            { locationName(e) }
                                        </IonItem>
                                        ))}
                                    </IonAccordion>
                                </IonAccordionGroup>
                                ))}
                            </IonAccordion>
                        ))}
                        </IonAccordionGroup>
                    </IonList>
                    }
                </IonContent>
            </div>
        </IonModal>
    );
};
  
export default LocationSelector;